export class Api3Error extends Error {
  constructor(public response: Response) {
    super('Authorization error');
  }
}
